module.exports = __webpack_public_path__ + "img/logo269.11f7b5ba.png";